// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"b630ba88","453":"bea2d936"}[chunkId] + ".chunk.js";
};